import { z } from "zod"
import { ShopifyCampaignTriggerEnum } from "../../campaigns/commonTypes"

export const UpsertShopifyCustomer = z.object({
  externalId: z.string(),
})

export const UpsertShopifyCustomers = z.object({
  shopifyHash: z.string(),
  customers: z.array(UpsertShopifyCustomer),
})

const ShopifyEventCustomerSchema = z
  .object({
    id: z.union([z.string(), z.number()]).nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    email: z.string().nullish(),
    phone: z.string().nullish(),
    locale: z.string().nullish(),
    default_address: z
      .object({
        country_code: z.string().nullish(),
        country: z.string().nullish(),
        phone: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
  })
  .passthrough()

const ShopifyLineItemSchema = z
  .object({
    id: z.union([z.string(), z.number()]).nullish(),
    product_id: z.union([z.string(), z.number()]).nullish(),
    variant_id: z.union([z.string(), z.number()]).nullish(),
    title: z.string().nullish(),
    name: z.string().nullish(),
    variant_title: z.string().nullish(),
    sku: z.string().nullish(),
    quantity: z.number().nullish(),
    price: z.union([z.string(), z.number()]).nullish(),
  })
  .passthrough()

const ShopifyEventOrderSchema = z
  .object({
    id: z.union([z.string(), z.number()]).nullish(),
    name: z.string().nullish(),
    email: z.string().nullish(),
    phone: z.string().nullish(),
    customer: ShopifyEventCustomerSchema.nullish(),
    line_items: z.array(ShopifyLineItemSchema).nullish(),
  })
  .passthrough()

export const ProcessShopifyEventWebhook = z.object({
  shopifyHash: z.string(),
  trigger: z.enum(ShopifyCampaignTriggerEnum),
  order: ShopifyEventOrderSchema,
})
